import '../lib/fittext';

const matchSize = (selector, direction) => {
	$.each(selector, function(idx, element) {
		if (typeof element !== 'string') {
			let { selClass, mod } = element;
			$.each($(selClass), (idx, ele) => {
				if ($(ele).hasClass('active')) {
					element.active = idx;
				}
			});
			$(selClass).addClass(mod);
		}
	});

	$.each(selector, function(idx, element) {
		if (typeof element === 'string') {
			$(element).css(direction, ''); // clear height to remeasure element's height
			let elementSizes = $(element).map(function() {
				return $(this)[direction]();
			}).get();
			let maxSize = Math.max.apply(null, elementSizes);
			$(element)[direction](maxSize);

		} else {
			let { selClass, mod, active } = element;
			$(selClass).css(direction, ''); // clear height to remeasure selClass's height
			let selClassSizes = $(selClass).map(function() {
				return $(this)[direction]();
			}).get();
			let maxSize = Math.max.apply(null, selClassSizes);
			$(selClass).removeClass(mod);
			$($(selClass)[active]).addClass(mod);
			$(selClass)[direction](maxSize);
		}
	});
};

export function setContentSizes (arr, way = 'height') {
	$(window).resize(() => matchSize(arr, way));
	$(document).ready(() => matchSize(arr, way));
};


const contentAjustments = () => {
	$('.appCTA_container .contentShifter').css('min-height', '');
	$('.appCTA_container .copy').css('width', '');
	$('.appCTA_container .phone').css({ 'height': '', 'overflow': '' });

	if ($('.nav-container .sticker_holder .couponSticker .logo').is('p')) {
		$('.nav-container .sticker_holder .couponSticker p.logo').fitText(0.66);
	}

	let couponHeight = $('.appCTA_container .couponHolder .couponPic').height();
	let heightSetter, sizerPicker = $('.appCTA_container').attr('id');

	heightSetter = sizerPicker === 'appCTA' ? $('.appCTA_container .phone').outerHeight(true) : $('.appCTA_container .contentShifter .positioner').outerHeight(true);

	$('.appCTA_container .couponHolder').height(couponHeight);

	if ($(window).width() >= 720) {
		$('.appCTA_container .contentShifter').css('min-height', heightSetter);

		let widthSetter = $('.appCTA_container .contentShifter .positioner').width();
		let currWidth = $('.appCTA_container .copy').width();
		if (currWidth > widthSetter) {
			$('.appCTA_container .copy').width(widthSetter);
		}
		setContentSizes(['.productCall2Action .brandonTitle', '.productCall2Action p']);

	} else {
		let sizePicker = Math.max(
			($('.appCTA_container .phone').height() / 2),
			($('.appCTA_container .copy:not(.mobile) .contentShifter').outerHeight(true))
		);
		$('.appCTA_container .phone').css({
			'height': sizePicker,
			'overflow': 'hidden'
		});
	}


	$('.appCTA_container .contentShifter .brandonTitle').css('white-space', '');
};

export function contentSizingAjustments () {
	$(window).resize(() => contentAjustments());
	$(document).ready(() => contentAjustments());
};
